import React, { useContext, useMemo } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../../context/Auth/AuthContext";

const SelectConection = ({ value, onChange, className, channel, isConnected = true, restrictToUserQueues = false }) => {
  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);

  const userQueueIds = useMemo(
    () => (user?.queues || []).map((q) => q.id),
    [user]
  );

  const filteredWhatsApps = useMemo(() => {
    if (loading || !whatsApps) return [];

    const shouldFilterByStatus = isConnected !== null && isConnected !== undefined;
    const showAllChannels = channel === null || channel === undefined || channel === "" || typeof channel !== "string";
    const channelList = !showAllChannels ? channel.split(" ").map((c) => c.trim()).filter(Boolean) : [];

    const applyQueueRestriction = restrictToUserQueues && userQueueIds.length > 0;

    return whatsApps.filter((item) => {
      if (value && item.id === value) {
        return true;
      }
      const itemIsConnected = item.status === "CONNECTED";
      if (shouldFilterByStatus && isConnected === true && !itemIsConnected) {
        return false;
      }
      if (!showAllChannels && !channelList.includes(item.channel)) {
        return false;
      }
      if (applyQueueRestriction) {
        const itemQueueIds = (item.queues || []).map((q) => q.id);
        if (
          itemQueueIds.length > 0 &&
          !itemQueueIds.some((id) => userQueueIds.includes(id))
        ) {
          return false;
        }
      }
      return true;
    });

  }, [whatsApps, channel, loading, restrictToUserQueues, userQueueIds, value]);

  const handleChange = (e) => onChange(e.target.value);

  return (
    <FormControl
      fullWidth
      margin="dense"
      size="small"
      className={className}
    >
      <Select
        fullWidth
        displayEmpty
        variant="outlined"
        value={value || ""}
        onChange={handleChange}
        MenuProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
        renderValue={() => {
          if (!value) return "Conexiones";
          const selected = filteredWhatsApps.find((i) => i.id === value);
          return selected ? selected.name : "Conexiones";
        }}
      >
        <MenuItem value="">Todas las conexiones</MenuItem>

        {filteredWhatsApps.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}

        {!filteredWhatsApps.length && (
          <MenuItem disabled>No hay conexiones disponibles</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default SelectConection;
